module.exports = __webpack_public_path__ + "trademark3.png?0fc2c7efc2b021777ce02919868820c4";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark3.png
// module id = 503
// module chunks = 0